// Variant switcher (R-U8) and the speed readout of the sync engine: a button of the rail that opens a panel beside it, so nothing
// floats over the content (quality review 30.10: the floating «Варианты» covered the last row of a list).

import { useSync, useStatus } from '../sync/react.tsx';
import { Icon } from '../ui/icons.tsx';
import { Popover, PopoverContent, PopoverTrigger, cx } from '../ui/primitives.tsx';
import { Tooltip } from '../ui/Tooltip.tsx';
import { VARIANTS, useVariant, type VariantName } from './variants.tsx';
import s from './shell.module.css';

export function VariantsButton() {
  return (
    <Popover>
      <Tooltip label="Варианты">
        <PopoverTrigger asChild>
          <button type="button" className={s.railBtn} aria-label="Варианты"><Icon name="sparkles" size={18} /></button>
        </PopoverTrigger>
      </Tooltip>
      <PopoverContent side="right" align="end" className={s.variantsBody}>
        {(Object.keys(VARIANTS) as VariantName[]).map((n) => <VariantRow key={n} name={n} />)}
        <Speed />
      </PopoverContent>
    </Popover>
  );
}

function VariantRow({ name }: { name: VariantName }) {
  const [v, set] = useVariant(name);
  return (
    <div className={s.vRow}>
      <span className={s.vLabel}>{VARIANTS[name].label}</span>
      <span className={s.vOpts}>
        {VARIANTS[name].options.map(([val, label]) => (
          <button key={val} type="button" className={cx(s.vOpt, v === val && s.vOn)} onClick={() => set(val)}>{label}</button>
        ))}
      </span>
    </div>
  );
}

function Speed() {
  const client = useSync();
  useStatus();
  const t = client.timings;
  const ms = (x?: number) => (x === undefined ? '—' : `${Math.round(x - t.start)} мс`);
  let records = 0;
  for (const ty of client.store.meta.types()) records += client.store.count(ty.id);
  return (
    <div className={s.speed}>
      <div>Данные: {t.source === 'cache' ? 'из кэша браузера' : 'с сервера'} · записей {records.toLocaleString('ru-RU')}</div>
      <div>Первый раздел: {ms(t.firstFocus)} · всё: {ms(t.loaded)}</div>
    </div>
  );
}
